/**
 * The quiz of each world that has one. A world without an entry has no quiz:
 * its `/:world/quiz` is a 404, its navigation has no Тест, and neither the
 * sitemap nor llms.txt lists it.
 */

import type { Quiz } from '../quiz.ts'
import { discworldQuiz } from './discworld.ts'

const QUIZZES: Readonly<Record<string, Quiz>> = {
  discworld: discworldQuiz,
}

export function quizFor(world: string): Quiz | null {
  return Object.hasOwn(QUIZZES, world) ? QUIZZES[world]! : null
}
